import BillingsOrderForwardTaxiTaxiDraftResponse, {
  BillingsOrderForwardTaxiTaxiDraftResponseItemBonusContributionFavorableDistance,
  BillingsOrderForwardTaxiTaxiDraftResponseItemBonusContributionOther,
  BillingsOrderForwardTaxiTaxiDraftResponseItemBonusContribution,
  BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType,
  BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionOther,
  BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionIncompatibleCar,
  BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionBeingLate,
  BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionWrongRoute,
  BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContribution,
  BillingsOrderForwardTaxiTaxiDraftResponseItemContribution,
  BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingActionContractProducerTaxi,
  BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingActionContract,
  BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingActionTransportingOrderCargoOrder,
  BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingActionTransportingOrder,
  BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingAction,
  BillingsOrderForwardTaxiTaxiDraftResponseItemBillingNode,
} from "../../../../../api/raily/billings/order-forward/taxi-taxi/draft/billings-order-forward-taxi-taxi-draft.response";
import BillingsOrderForwardTaxiTaxiDraft, {
  BillingsOrderForwardTaxiTaxiDraftBonusContributionFavorableDistance,
  BillingsOrderForwardTaxiTaxiDraftContributionType,
  BillingsOrderForwardTaxiTaxiDraftBonusContributionOther,
  BillingsOrderForwardTaxiTaxiDraftBonusContribution,
  BillingsOrderForwardTaxiTaxiDraftPenaltyContributionOther,
  BillingsOrderForwardTaxiTaxiDraftPenaltyContributionIncompatibleCar,
  BillingsOrderForwardTaxiTaxiDraftPenaltyContributionBeingLate,
  BillingsOrderForwardTaxiTaxiDraftPenaltyContributionWrongRoute,
  BillingsOrderForwardTaxiTaxiDraftPenaltyContribution,
  BillingsOrderForwardTaxiTaxiDraftContribution,
  BillingsOrderForwardTaxiTaxiDraftOrderForwardingActionContractProducerTaxi,
  BillingsOrderForwardTaxiTaxiDraftOrderForwardingActionContract,
  BillingsOrderForwardTaxiTaxiDraftOrderForwardingActionTransportingOrderCargoOrder,
  BillingsOrderForwardTaxiTaxiDraftOrderForwardingActionTransportingOrder,
  BillingsOrderForwardTaxiTaxiDraftOrderForwardingAction,
  BillingsOrderForwardTaxiTaxiDraftBillingNode,
} from "./billings-order-forward-taxi-taxi-draft";

const createBillingBonusContributionFavorableDistance = (
  contribution: BillingsOrderForwardTaxiTaxiDraftResponseItemBonusContributionFavorableDistance,
): BillingsOrderForwardTaxiTaxiDraftBonusContributionFavorableDistance => {
  return {
    comment: contribution.comment,
    distance: contribution.distance,
    rate: contribution.rate,
    type: BillingsOrderForwardTaxiTaxiDraftContributionType.BONUS_FAVORABLE_DISTANCE,
  };
};

const createBillingBonusContributionOther = (
  contribution: BillingsOrderForwardTaxiTaxiDraftResponseItemBonusContributionOther,
): BillingsOrderForwardTaxiTaxiDraftBonusContributionOther => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsOrderForwardTaxiTaxiDraftContributionType.BONUS_OTHER,
  };
};

const createBillingBonusContribution = (
  contribution: BillingsOrderForwardTaxiTaxiDraftResponseItemBonusContribution,
): BillingsOrderForwardTaxiTaxiDraftBonusContribution => {
  switch (contribution.type) {
    case BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.BONUS_FAVORABLE_DISTANCE:
      return createBillingBonusContributionFavorableDistance(
        contribution as BillingsOrderForwardTaxiTaxiDraftResponseItemBonusContributionFavorableDistance,
      );
    case BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.BONUS_OTHER:
      return createBillingBonusContributionOther(
        contribution as BillingsOrderForwardTaxiTaxiDraftResponseItemBonusContributionOther,
      );
  }
};

const createBillingPenaltyOther = (
  contribution: BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionOther,
): BillingsOrderForwardTaxiTaxiDraftPenaltyContributionOther => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsOrderForwardTaxiTaxiDraftContributionType.PENALTY_OTHER,
  };
};

const createBillingPenaltyIncompatibleCar = (
  contribution: BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionIncompatibleCar,
): BillingsOrderForwardTaxiTaxiDraftPenaltyContributionIncompatibleCar => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsOrderForwardTaxiTaxiDraftContributionType.PENALTY_INCOMPATIBLE_CAR,
  };
};

const createBillingPenaltyBeingLate = (
  contribution: BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionBeingLate,
): BillingsOrderForwardTaxiTaxiDraftPenaltyContributionBeingLate => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsOrderForwardTaxiTaxiDraftContributionType.PENALTY_BEING_LATE,
  };
};

const createBillingPenaltyWrongRoute = (
  contribution: BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionWrongRoute,
): BillingsOrderForwardTaxiTaxiDraftPenaltyContributionWrongRoute => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsOrderForwardTaxiTaxiDraftContributionType.PENALTY_WRONG_ROUTE,
  };
};

const createBillingPenaltyContribution = (
  contribution: BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContribution,
): BillingsOrderForwardTaxiTaxiDraftPenaltyContribution => {
  switch (contribution.type) {
    case BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.PENALTY_BEING_LATE:
      return createBillingPenaltyBeingLate(
        contribution as BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionBeingLate,
      );
    case BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.PENALTY_OTHER:
      return createBillingPenaltyOther(
        contribution as BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionOther,
      );
    case BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.PENALTY_INCOMPATIBLE_CAR:
      return createBillingPenaltyIncompatibleCar(
        contribution as BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionIncompatibleCar,
      );
    case BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.PENALTY_WRONG_ROUTE:
      return createBillingPenaltyWrongRoute(
        contribution as BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionWrongRoute,
      );
  }
};

const createBillingContribution = (
  contribution: BillingsOrderForwardTaxiTaxiDraftResponseItemContribution,
): BillingsOrderForwardTaxiTaxiDraftContribution => {
  switch (contribution.type) {
    case BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.BONUS_FAVORABLE_DISTANCE:
    case BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.BONUS_OTHER:
      return createBillingBonusContribution(
        contribution as BillingsOrderForwardTaxiTaxiDraftResponseItemBonusContribution,
      );
    case BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.PENALTY_BEING_LATE:
    case BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.PENALTY_OTHER:
    case BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.PENALTY_INCOMPATIBLE_CAR:
    case BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.PENALTY_WRONG_ROUTE:
      return createBillingPenaltyContribution(
        contribution as BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContribution,
      );
  }
};

const createBillingContributions = (
  contributions: BillingsOrderForwardTaxiTaxiDraftResponseItemContribution[],
): BillingsOrderForwardTaxiTaxiDraftContribution[] => {
  return contributions.map(createBillingContribution);
};

const createOrderForwardingActionContractProducerTaxi = (
  producerTaxi: BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingActionContractProducerTaxi,
): BillingsOrderForwardTaxiTaxiDraftOrderForwardingActionContractProducerTaxi => {
  return {
    displayName: producerTaxi.displayName,
  };
};

const createOrderForwardingActionContract = (
  orderForwardingAction: BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingActionContract,
): BillingsOrderForwardTaxiTaxiDraftOrderForwardingActionContract => {
  return {
    distanceRate: orderForwardingAction.distanceRate,
    haltingTimeAfterMinutes: orderForwardingAction.haltingTimeAfterMinutes,
    haltingTimeRate: orderForwardingAction.haltingTimeRate,
    model: orderForwardingAction.model,
    producerTaxi: createOrderForwardingActionContractProducerTaxi(
      orderForwardingAction.producerTaxi,
    ),
  };
};

const createOrderForwardingActionTransportingOrderCargoOrder = (
  cargoOrder: BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingActionTransportingOrderCargoOrder,
): BillingsOrderForwardTaxiTaxiDraftOrderForwardingActionTransportingOrderCargoOrder => {
  return {
    humanId: cargoOrder.humanId,
    uuid: cargoOrder.id,
  };
};

const createOrderForwardingActionTransportingOrder = (
  orderForwardingAction: BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingActionTransportingOrder,
): BillingsOrderForwardTaxiTaxiDraftOrderForwardingActionTransportingOrder => {
  return {
    cargoOrder: createOrderForwardingActionTransportingOrderCargoOrder(
      orderForwardingAction.cargoOrder,
    ),
  };
};

const createOrderForwardingAction = (
  orderForwardingAction: BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingAction,
): BillingsOrderForwardTaxiTaxiDraftOrderForwardingAction => {
  return {
    contract: createOrderForwardingActionContract(
      orderForwardingAction.contract,
    ),
    uuid: orderForwardingAction.id,
    transportingOrder: createOrderForwardingActionTransportingOrder(
      orderForwardingAction.transportingOrder,
    ),
  };
};

const createBillingNode = (
  node: BillingsOrderForwardTaxiTaxiDraftResponseItemBillingNode,
): BillingsOrderForwardTaxiTaxiDraftBillingNode => {
  return {
    allowCharge: node.allowCharge,
    checkoutDate: node.checkoutDate,
    checkoutEventUuid: node.checkoutEventId,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    uuid: node.id,
    lat: node.lat,
    lon: node.lon,
    nodeUuid: node.nodeId,
    orderUuid: node.orderId,
    plannedDate: node.plannedDate,
    plannedDistance: node.plannedDistance,
  };
};

const createBillingNodes = (
  nodes: BillingsOrderForwardTaxiTaxiDraftResponseItemBillingNode[],
): BillingsOrderForwardTaxiTaxiDraftBillingNode[] => {
  return nodes.map(createBillingNode);
};

const create = (
  response: BillingsOrderForwardTaxiTaxiDraftResponse,
): BillingsOrderForwardTaxiTaxiDraft => {
  const data = response.data;

  return {
    allContributionsAmount: data.allContributionsAmount,
    amountForChargeHaltings: data.amountForChargeHaltings,
    amountForChargeHighways: data.amountForChargeHighways,
    amountForDistance: data.amountForDistance,
    billingContributions: createBillingContributions(data.billingContributions),
    billingNodes: createBillingNodes(data.billingNodes),
    date: data.date,
    distance: data.distance,
    orderForwardingAction: createOrderForwardingAction(
      data.orderForwardingAction,
    ),
    passengers: data.passengers,
    planEntryUuid: data.planEntryId,
    sumOfBonuses: data.sumOfBonuses,
    sumOfPenalties: data.sumOfPenalties,
  };
};

const billingsOrderForwardTaxiTaxiDraftFactory = {
  create,
};

export default billingsOrderForwardTaxiTaxiDraftFactory;
